export default __webpack_public_path__ + "static/media/JP Logo.jpg.24ce3eb7.jpg";